import { useEffect } from 'react';
import useAuth from 'context/Auth';
import { QueryResult } from '@apollo/client';
import { singletonHook } from 'react-singleton-hook';
import { GraphQLDocumentObjectType } from 'types/documents-types';
import { useLandaAuthedApiLazyQuery } from '../../../api/graphql/landa_api';
import { OptionsType } from '../../../api/graphql/functions/useLandaLazyQuery';
import { useUserDocumentsStore } from 'stores/UserDocuments/financialIdentities';
import { USER_DOCUMENTS_QUERY } from '../../../../graphql/account/queries/userDocumentsQuery';

const init: {
  request?: ((innerConfig?: OptionsType) => Promise<QueryResult>) | undefined;
  loading: boolean;
  userDocuments?: GraphQLDocumentObjectType[];
  userTaxesDocuments?: GraphQLDocumentObjectType[];
} = {
  userDocuments: [],
  userTaxesDocuments: [],
  request: undefined,
  loading: false,
};

const useUserDocuments = () => {
  const { isLoggedIn } = useAuth();
  const {
    userDocuments,
    userTaxesDocuments,
    setUserDocuments,
    setTaxesDocuments,
  } = useUserDocumentsStore();
  const [fetchUserDocuments, { loading }] =
    useLandaAuthedApiLazyQuery(USER_DOCUMENTS_QUERY);

  const initialize = () => {
    fetchUserDocuments({
      onCompleted: (data) => {
        setUserDocuments(data?.userDocuments);
        setTaxesDocuments(data?.userTaxesDocuments);
      },
    });
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    initialize();
  }, [isLoggedIn]);

  return {
    request: fetchUserDocuments,
    loading: loading && !userDocuments,
    userDocuments,
    userTaxesDocuments,
  };
};

export default singletonHook(init, useUserDocuments);
